import map from './views/map'

export default
{
    locale : 'fr',

    // views
    map : map
};


// WEBPACK FOOTER //
// ./src/app/locale/fr/index.js